// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

export interface NotificationCardTelemetryObjects {
    container: TelemetryObjectBase;
    closeButton: TelemetryObjectBase;
    messageLink: TelemetryObjectBase;
    deletedMessageLink: TelemetryObjectBase;
    profileLink: TelemetryObjectBase;
}

export const notificationCardTelemetryContracts = {
    // Toast > Scenario-1 contentview
    reply: {
        name: "CommentRespondToast",
        content: { type: TelemetryContentType.Toast }
    },
    // Toast > Scenario-2 and Scenario-5 click
    closeButton: {
        name: "Close",
        behavior: TelemetryBehaviorType.Close,
        content: { headline: "Close", type: TelemetryContentType.Toast }
    },
    // Toast > Scenario-3 click
    commentLink: {
        name: "GoToComment",
        behavior: TelemetryBehaviorType.Navigate,
        content: { type: TelemetryContentType.Toast }
    },
    // Toast > Scenario-4 contentview
    achievement: {
        name: "CommunityProfileAchievementBadge",
        content: { type: TelemetryContentType.Toast }
    },
    // Toast > Scenario-6 click
    achievementLink: {
        name: "Achievement",
        behavior: TelemetryBehaviorType.Navigate,
        content: { type: TelemetryContentType.Toast }
    },
    reaction: {
        name: "ReactionToast",
        content: { type: TelemetryContentType.Toast }
    },
    follow: {
        name: "FollowToast",
        content: { type: TelemetryContentType.Toast }
    },
    deletedMessageLink: {
        name: "GoToGuidelines",
        behavior: TelemetryBehaviorType.Navigate,
        content: { headline: "GoToGuidelines", type: TelemetryContentType.Toast }
    },
    profileLink: {
        name: "GoToProfile",
        behavior: TelemetryBehaviorType.Navigate,
        content: { headline: "GoToProfile", type: TelemetryContentType.Toast }
    }
};